import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import LoadingSpinner from './LoadingSpinner'

import type { FC } from 'react'

type OnceLoadedProps = { loaded: boolean; children: React.ReactNode }

const OnceLoaded: FC<OnceLoadedProps> = ({ loaded = false, children }) => {
  if (!loaded)
    return (
      <SimpleCard className="flex-1 !rounded p-6">
        <LoadingSpinner />
      </SimpleCard>
    )

  return <>{children}</>
}

export default OnceLoaded
